import React from 'react'
import { ThemeProvider } from 'styled-components'
import Layout from './Layout'
import EnterpriseLayout from './EnterpriseLayout'
import PaasLayout from './paaslayout'
import HeaderNavs from './HeaderNavs'
import HeaderTabs from './HeaderTabs'
import AuthContext from '../auth-context'
import { safeParseJSON, findMenuInfoByPath, getCheckAuth } from '../utils'
import ActionsContext from './ActionsContext'
import createActions from './createActions'
import { getLanguageStore } from './storage'

export const HeaderActionItem = (props) => <li {...props}>{props.children}</li>

export * from './HeaderNavs'

const TNTLayout = ({ type, config, showMenuInIframe = false, ...props }) => {
  const headerHeight = props.size === 'large' ? 60 : 50
  const theme = {
    size: props.size,
    compatible: props.compatible,
    headerHeight,
    primaryColor: '#126BFB',
    secondaryColor: '#005df4',
    primaryTextColor: '#17233D', // 1
    secondaryTextColor: 'rgba(23,35,61,.8)', // .8
    lightIconColor: 'rgba(23,35,61,.7)', // .7
    headerActionsColor: 'rgba(23,35,61,.6)', // .6
    borderColor: '#B2BECD',
    dividerColor: '#E1E6EE',
    lightBgColor: '#F1F2F5',
    blueBgColor: '#1D4295', // 默认的蓝色主题
  }
  const isInIframe = showMenuInIframe
    ? false
    : self !== top && !window.navigator.userAgent.includes('mo-fang-app')
  // 前期拼写错误，导致需要兼容处理
  const extraHeaderActions = props.extraHeaderActions || props.extralHeaderActions
  const extendMap =
    typeof props.extendMap === 'string' ? safeParseJSON(props.extendMap, {}) : props.extendMap
  const {
    displayType = 'default',
    menuAlignMode,
    globalNavigation = false,
    language = ['cn'],
    themeSwitch = true,
  } = extendMap || {}
  const userInfo = props.userInfo || {}
  const actionsContextValue = createActions({
    language: getLanguageStore() || userInfo.lang || 'cn',
  })
  const onLanguageChange = (language) => {
    actionsContextValue.setLanguage(language)
    props.onLanguageChange && props.onLanguageChange(language)
  }

  // layout上的指定的属性优先级会高于extendMap中的属性
  type = type || displayType
  config = Object.assign(
    {
      language: language?.length > 1,
      theme: themeSwitch,
      avatar: true,
      globalNavigation,
    },
    config
  )

  return (
    <ThemeProvider theme={theme}>
      <AuthContext.Provider value={getCheckAuth(props.menus)}>
        <ActionsContext.Provider value={actionsContextValue}>
          {type === 'paas' && (
            <PaasLayout
              menuAlignMode={menuAlignMode}
              config={config}
              {...props}
              extraHeaderActions={extraHeaderActions}
              isInIframe={isInIframe}
              userInfo={userInfo}
              onLanguageChange={onLanguageChange}
            />
          )}
          {type === 'enterprise' && (
            <EnterpriseLayout
              menuAlignMode={menuAlignMode}
              config={config}
              {...props}
              extraHeaderActions={extraHeaderActions}
              isInIframe={isInIframe}
              userInfo={userInfo}
              onLanguageChange={onLanguageChange}
              type={type}
            />
          )}
          {(!type || !['paas', 'enterprise'].includes(type)) && (
            <Layout
              menuAlignMode={menuAlignMode}
              config={config}
              {...props}
              extraHeaderActions={extraHeaderActions}
              isInIframe={isInIframe}
              userInfo={userInfo}
              onLanguageChange={onLanguageChange}
            />
          )}
        </ActionsContext.Provider>
      </AuthContext.Provider>
    </ThemeProvider>
  )
}

TNTLayout.HeaderActionItem = HeaderActionItem
TNTLayout.HeaderNavs = HeaderNavs
TNTLayout.HeaderTabs = HeaderTabs
TNTLayout.AuthContext = AuthContext

TNTLayout.findMenuInfoByPath = findMenuInfoByPath

export default TNTLayout
